import store from '@/store'
import moment from 'moment'
// import axios from '@/util/axios'
// import createPersistedState from 'vuex-persistedstate'
import * as apiLogin from '@/api/login'
import * as apiCommon from '@/api/common'

const getDefaultState = () => {
  return {
    token: null,
    refreshToken: null,
    lastDate: null,
    refresh: false,
    exchangeToken: null
  }
}

const auth = {
  // plugins: [createPersistedState({ key: 'lc-app' })],
  namespaced: true,
  state: getDefaultState(),
  getters: {
    token: state => state.token,
    refreshToken: state => state.refreshToken,
    lastDate: state => state.lastDate,
    isTimeOut(state) {
      const dateFrom = state.lastDate
      const dateTo = moment()
      const dateDiff = dateTo.diff(dateFrom, 'minutes')

      // 最終アクセスから60分以上経過していればログアウト
      const result = dateDiff > 60
      return result
    },
    isRefresh: state => state.refresh,
    exchangeToken: state => state.exchangeToken
  },
  mutations: {
    setToken(state, payload) {
      const { token, refreshToken } = payload
      state.token = token
      state.refreshToken = refreshToken
      state.lastDate = moment()
    },
    setExchangeToken(state, exchangeToken) {
      state.exchangeToken = exchangeToken
    },
    updateDate(state) {
      state.lastDate = moment()
    },
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
    setRefresh(state) {
      state.refresh = true
    },
    resetRefresh(state) {
      state.refresh = false
    }
  },
  actions: {

    /**
     * ログイン
     * @param {} コンテキストの分割代入
     * @param {} ペイロード
     */
    async login({ commit }, params) {

      const result = {}

      await apiLogin.login(params)
        .then(response => {
          const data = response.data

          if (typeof data.status !== 'undefined') {
            if (data.status === 0) {
              const token = data.token ?? ''
              const refreshToken = data.refresh_token ?? ''

              if (token) {
                // トークンをVuexに保持する
                commit('setToken', { token, refreshToken })
              }
            } else {
            }
          }

          result.response = response
        })
        .catch(error => {
          result.error = error
        })

      return result
    },

    /**
     * ログアウト
     * @param {} コンテキストの分割代入
     */
    logout({ commit }) {

      apiCommon.logout()
        .then(response => {
          const data = response.data
          if (typeof data.status !== 'undefined') {
            if (response.status === 0) {
              // ステータスが0の場合
              commit('resetState')
            } else {
              // ステータスが0以外の場合
              // ログアウト失敗(API処理エラー)
            }
          }
        })
    },

    /**
     * URLにトークンが付与されてアクセスした場合の認証処理
     * (フロントエンドログインや書籍プレビューなど)
     * @param {*} token 
     */
    async checkToken({ commit }, token, refreshToken) {

      let isAuthorized = false

      if (token !== '') {
        // プロフィール取得APIをコール
        const params = {}
        params.token = token

        await store
          .dispatch('profile/fetch', params)
          .then(async(map) => {
            const { response, error } = map
            if (response) {
              const { data } = response

              if (data.status === 0) {
                // 認証成功
                isAuthorized = true

                // トークンを設定し保持する
                commit('setToken', { token: token, refreshToken: refreshToken })
              }
            } 
          })
      }

      return isAuthorized
    },
    setExchangeToken({ commit }, { exchangeToken }) {
      commit('setExchangeToken', exchangeToken)
    },
    apiCall({ commit }) {
      commit('updateDate')
    },
    setToken({ commit }, { token, refreshToken }) {
      commit('setToken', { token, refreshToken })
    },
    beginRefresh({ commit }) {
      commit('setRefresh')
    },
    completeRefresh({ commit }) {
      commit('resetRefresh')
    }
  }
}

export default auth
